import React from 'react';
import { CheckCheck, ExternalLink, FileText, Image as ImageIcon, Reply, Video } from 'lucide-react';
import { componentOf, fillText } from './broadcastModel';

const MEDIA_ICONS = { IMAGE: ImageIcon, VIDEO: Video, DOCUMENT: FileText };

// A WhatsApp-style bubble showing the template as one sample person gets it.
export default function MessagePreview({ template, variables = {}, sample, caption = 'Preview' }) {
  const header = componentOf(template, 'HEADER');
  const body = componentOf(template, 'BODY');
  const footer = componentOf(template, 'FOOTER');
  const buttons = componentOf(template, 'BUTTONS')?.buttons || [];
  const format = String(header?.format || 'TEXT').toUpperCase();
  const MediaIcon = MEDIA_ICONS[format];
  const mediaLink = variables['header.media']?.value;

  return (
    <figure className="wa-phone" aria-label={`${caption}: how the message looks on WhatsApp`}>
      <div className="wa-phone-bar">
        <span className="wa-phone-avatar" aria-hidden="true">{(sample?.business || 'A').slice(0, 1)}</span>
        <span className="ws-grow" style={{ minWidth: 0 }}>
          <strong>{sample?.business || 'Your business'}</strong>
          <small>Business account</small>
        </span>
      </div>
      <div className="wa-phone-chat">
        {!template && <p className="wa-phone-empty">Choose a template to see the message.</p>}
        {template && (
          <div className="wa-bubble">
            {MediaIcon && (
              <div className={`wa-bubble-media${mediaLink ? ' has-link' : ''}`}>
                {format === 'IMAGE' && /^https:\/\//i.test(mediaLink || '') ? <img src={mediaLink} alt="" onError={(event) => { event.currentTarget.style.display = 'none'; }} /> : null}
                <MediaIcon size={26} aria-hidden="true" />
                <span>{mediaLink ? `Your ${format.toLowerCase()}` : `Add ${format === 'IMAGE' ? 'an image' : `a ${format.toLowerCase()}`} link`}</span>
              </div>
            )}
            {format === 'TEXT' && header?.text && <p className="wa-bubble-title">{fillText(header.text, 'header', variables, sample)}</p>}
            {body?.text && <p className="wa-bubble-body">{fillText(body.text, 'body', variables, sample)}</p>}
            {footer?.text && <p className="wa-bubble-footer">{footer.text}</p>}
            <span className="wa-bubble-time">10:24 AM <CheckCheck size={14} aria-hidden="true" /></span>
            {buttons.length > 0 && (
              <div className="wa-bubble-buttons">
                {buttons.map((button, index) => (
                  <span key={`${button.text}-${index}`} className="wa-bubble-button">
                    {String(button.type).toUpperCase() === 'URL' ? <ExternalLink size={14} aria-hidden="true" /> : <Reply size={14} aria-hidden="true" />}
                    {button.text}
                  </span>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
      {template && <figcaption className="wa-phone-caption">{caption} for <strong>{sample?.name || 'a customer'}</strong></figcaption>}
    </figure>
  );
}
